import { Box, Button, Paper, Typography } from '@mui/material';
import styled, { keyframes } from 'styled-components';

export const StyledIconTextContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
`;
export const StyledSpaceBetweenBox = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const StyledCenterBox = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export const StyledPaper = styled(Paper)`
  position: relative;
  margin-bottom: 16px;
  border-radius: 8px;
`;

export const StyledLinkContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StyledBox = styled(Box)`
  padding: 24px;
`;
export const StyledFlexContainer = styled(Box)`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const StyledFlexItem = styled(Paper)`
  padding: 16px;
  margin-bottom: 16px;
  flex: 1;
  min-width: 40%;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const pulse = keyframes`
  0%, 100% {
    transform: scale(1); 
  }
  50% {
    transform: scale(1.1); 
  }
`;

export const StyledButton = styled(Button)`
  animation: ${pulse} 2.0s infinite; 
  transition: all 0.3s ease; 

  &:hover {
    animation: none; 
    transform: scale(1.2); 
  }
}
`;
export const StyledCenterDiv = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 18px;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
`;
export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 500px;
  overflow: hidden;
`;

export const StyledImage = styled.img`
  width: 100%;
  height: 120%;
  object-fit: cover;
  transform: translateY(-10%);
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  pointer-events: none;
`;
export const StyledTypo = styled(Typography)`
  color: white;
  font-weight: bold;
  margin-bottom: 10px;
`;
